import {actions as A} from '../constants/actions';

const defaultState = {
  list: {
    gridSimilarAssetsColumns: [],
    gridFirmColumns: [],
    gridSharedColumns: [],
    gridSurveyAssetsColumns: [],
    gridTaxAuthorityColumns: [],
  },
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_STEP_9_GIRD_SHARED_DATA:
      return {...state, loading: true, error: false, errorMessage: null};

    case A.SET_STEP_9_GRID_SAVED_COLUMNS:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        list: {...payload}
      };

    case A.UPDATE_STEP_9_GRID_SAVED_COLUMN:
      const {id, column, value} = payload;
      const [oldRow] = state.list[id].filter(item => item.columnName === column);
      const newRow = {...oldRow, display: value};
      const restRows = state.list[id].filter(item => item.columnName !== column);
      const list = {
        ...state.list,
        [id]: [...restRows, newRow]
      };

      return {...state, loading: false, error: false, errorMessage: null, list};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

